<div class="iguau-profile-admin mb-3 bg-white rounded-4 p-3 small div-shadow" *ngIf="misdatos.rol == 'administrator'">
  <div class="row">
    <div class="col-auto">
      <b>ID:</b> {{perfil.ID}}
    </div>
    <div class="col-auto">
      <b>Username:</b> {{perfil.username}}
    </div>
    <div class="col-auto" *ngIf="perfil.login_provider">
      <b>Proveedor:</b> {{perfil.login_provider}}
    </div>
    <div class="col-auto">
      <b>Registro:</b> {{perfil.user_registered | cuandoFechas}}
    </div>
    <div class="col-auto" *ngIf="perfil.last_login">
      <b>Último login:</b> {{perfil.last_login | cuandoFechas}}
    </div>
  </div>
  <div class="row mt-2" *ngIf="misdatos.ID != perfil.ID">
    <div class="col-auto" *ngIf="perfil.cuenta_bloqueada != 1">
      <a class="pointer custom-link a-dark" (click)="bloquearCuenta(perfil.ID)">
        <i class="fa-solid fa-ban me-1"></i> Bloquear
      </a>
    </div>
    <div class="col-auto" *ngIf="perfil.cuenta_bloqueada == 1">
      <a class="pointer custom-link a-dark" (click)="desbloquearCuenta(perfil.ID)">
        <i class="fa-solid fa-ban me-1"></i> Desbloquear
      </a>
    </div>
    <div class="col-auto">
      <a class="pointer custom-link a-dark" (click)="eliminarCuenta(perfil.ID)">
        <i class="fa-solid fa-trash me-1"></i> Eliminar
      </a>
    </div>
  </div>
</div>
